import { HttpError, useList } from "@refinedev/core";
import { TranslationOutlined } from "@ant-design/icons";
import { Card, Typography, Space, Form, Flex, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useForm } from "@refinedev/antd";
import { SETTINGS_RES_ID } from "utility/constants";
import { useLocaleStore } from "stores/localeStore";
import { ISettings } from "interfaces";

const { Text, Title } = Typography;

export const GlobalSettings: React.FC = () => {
  const localeState = useLocaleStore();

  const { data } = useList<ISettings, HttpError>({
    resource: SETTINGS_RES_ID,
    meta: { headers: { lang: localeState.locale } },
    pagination: {
      pageSize: 10,
    },
  });

  const { formProps, saveButtonProps } = useForm<ISettings>({
    meta: { headers: { lang: localeState.locale } },
    action: "edit",
    id: data?.data[0]?.id,
    resource: SETTINGS_RES_ID,
  });

  return (
    <Space direction="vertical" size="large" style={{ display: "flex" }}>
      <Card bordered={false} className="criclebox h-full">
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
          <Flex wrap="wrap" gap="large" className="align-center">
            <TranslationOutlined style={{ fontSize: "30px", color: "#626262" }} />
            <div>
              <Title level={4} style={{ marginBottom: "0px" }}>
                AI-översättning
              </Title>
              <Text style={{ color: "#626262" }}>
                Instruktioner som används vid AI-översättning
              </Text>
            </div>
          </Flex>
          <Form
            {...formProps}
            layout="vertical"
            initialValues={{
              ...formProps.initialValues,
            }}
          >
            <Form.Item label="AI instruktioner vid översättning" name="context">
              <TextArea rows={10} />
            </Form.Item>
            <Button type="primary" {...saveButtonProps}>
              Spara
            </Button>
          </Form>
        </Space>
      </Card>
    </Space>
  );
};
